import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconTournamentOn = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-tournament-on_svg__a)"
      d="M23.094 5.742c0 .117.742 3.32-1.407 6.367-1.484 2.188-3.945 3.711-7.343 4.61a1.676 1.676 0 0 0-1.211 1.601c0 .938.742 1.68 1.68 1.68h.195c1.015 0 1.875.86 1.875 1.875 0 .352-.235.625-.586.625H7.586c-.313 0-.586-.273-.586-.625C7 20.859 7.82 20 8.875 20h.156c.938 0 1.719-.742 1.68-1.68 0-.742-.469-1.406-1.211-1.601-3.398-.899-5.86-2.422-7.305-4.61C.125 9.063.867 5.86.867 5.742c.117-.43.508-.742.938-.742H5.75a7.09 7.09 0 0 1 0-1.29c0-.663.547-1.21 1.25-1.21h9.96c.704 0 1.25.547 1.25 1.21.04.392.04.821 0 1.29h3.946c.43 0 .82.313.938.742ZM3.758 11.094c.898 1.367 2.344 2.422 4.258 3.203C6.57 12.03 5.984 9.219 5.75 6.875H2.625c-.04.938.04 2.617 1.133 4.219Zm16.445 0c1.094-1.602 1.172-3.281 1.133-4.219H18.21c-.234 2.344-.82 5.156-2.266 7.422 1.914-.781 3.36-1.836 4.258-3.203Z"
    />
    <defs>
      <linearGradient
        id="icon-tournament-on_svg__a"
        x1={23.5}
        x2={3.694}
        y1={2}
        y2={24.777}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconTournamentOn;
